// Realizace — galerie realizací (Swiper, jedna fotka na slide, adaptivní výška)
// a sekce „Takto nás hodnotíte“ načtená ze stránky hodnocení obchodu.
// HTML stránky nahrává Kolo do administrace (src/html/realizace.html), tady se na něj jen navazuje.
// /cache/ verze občas vrátí místo hodnocení titulku (naměřeno 15. 9. 2026) — pak zkusíme necachovanou
const realizaceReviewsSources = ["/cache/hodnoceni-obchodu/", "/hodnoceni-obchodu/"];
const realizaceReviewsTimeout = 10000;

function initRealizaceGallery() {
    const settings = shopDataLayer.realizace.gallery;

    $(".myrealizace-gallery").each(function () {
        const $gallery = $(this);
        const $list = $gallery.find(".myrealizace-gallery__list").first();

        if (!$list.length || $list.hasClass("swiper-wrapper")) {
            return;
        }

        // Editor administrace umí položky obalit dalším prvkem — srovnáme je pod seznam
        const $items = $list.find(".myrealizace-gallery__item");
        if (!$items.length) {
            return;
        }
        $items.appendTo($list);
        $list.children(":not(.myrealizace-gallery__item)").remove();

        $list.addClass("swiper-wrapper").wrap("<div class='swiper myrealizace-gallery__swiper'></div>");
        $items.addClass("swiper-slide");

        const $swiper = $list.parent(".myrealizace-gallery__swiper");
        const hasNavigation = $items.length > 1;
        let $navi = $();

        if (hasNavigation) {
            $navi = $("<div class='myswiper-navi myrealizace-gallery__navi'>" +
                "<div class='swiper-button-prev myswiper-prev'></div>" +
                "<div class='swiper-button-next myswiper-next'></div>" +
                "<div class='swiper-pagination'></div>" +
            "</div>").insertAfter($swiper);
            $gallery.addClass("has-navigation");
        }

        const gallerySwiper = new Swiper($swiper[0], {
            slidesPerView: 1,
            spaceBetween: 20,
            autoHeight: settings.autoHeight,
            watchOverflow: true,
            pagination: hasNavigation ? {
                el: $navi.find(".swiper-pagination")[0],
                clickable: true,
            } : false,
            navigation: hasNavigation ? {
                nextEl: $navi.find(".myswiper-next")[0],
                prevEl: $navi.find(".myswiper-prev")[0],
            } : false,
        });

        // Výška slidu se ustálí až po načtení fotky
        $list.find("img").on("load", function () {
            gallerySwiper.updateAutoHeight(0);
        });

        // Realizace se neprokliká, odkaz vede na fotku a otevře ji zvětšenou
        if (typeof $.fn.colorbox === "function") {
            $items.colorbox({
                rel: "myrealizace-gallery",
                photo: true,
                maxWidth: "95%",
                maxHeight: "95%",
            });
        }
    });
}

function buildRealizaceReviews(title) {
    const hp = shopDataLayer.homepage.reviews;

    return (
        "<div class='reviews'>" +
            "<h2 class='reviews-title'>" + title + "</h2>" +
            "<div class='reviews-inner'></div>" +
            "<div class='btn-holder'>" +
                "<a href='" + hp.readMore.link + "' class='my-btn'>" + hp.readMore.text + "</a>" +
                "<a href='" + hp.addReview.link + "' class='my-btn main-btn'>" + hp.addReview.text + "</a>" +
            "</div>" +
        "</div>"
    );
}

function initRealizaceReviews() {
    const settings = shopDataLayer.realizace.reviews;
    const $page = $(".myrealizace").first();

    if (!settings.enabled || !$page.length) {
        return;
    }

    let $holder = $page.find(".myrealizace-reviews").first();
    if (!$holder.length) {
        $holder = $("<section class='myrealizace-reviews'></section>").appendTo($page);
    }

    if ($holder.is(".is-loading, .is-loaded, .is-failed")) {
        return;
    }

    $holder.addClass("is-loading").html(
        "<div class='myloader' role='status'>" +
            "<span class='myloader-spinner'></span>" +
            "<span class='myloader-text'>" + settings.loadingText + "</span>" +
        "</div>"
    );

    const renderReviews = function ($votes) {
        const $reviews = $(buildRealizaceReviews(settings.title));

        $votes.each(function () {
            const $vote = $(this).clone();

            $vote.find(".vote-name").appendTo($vote);
            if ($vote.find(".vote-name span").is(":empty")) {
                $vote.find(".vote-name span").html(shopDataLayer.homepage.reviews.noName);
            }
            $reviews.find(".reviews-inner").append($vote);
        });

        // Chybějící místa doplní záloha recenzí ze shopDataLayer
        fillBackupReviews($reviews.find(".reviews-inner"), settings.count);

        $holder.removeClass("is-loading").addClass("is-loaded").empty().append($reviews);
    };

    loadRealizaceVotes(0, settings, renderReviews, function () {
        // Ani jeden zdroj nevrátil vhodnou recenzi — zobrazí se jen záloha
        renderReviews($());
    });
}

function loadRealizaceVotes(index, settings, onSuccess, onFail) {
    if (index >= realizaceReviewsSources.length) {
        onFail();
        return;
    }

    const tryNext = function () {
        loadRealizaceVotes(index + 1, settings, onSuccess, onFail);
    };

    // jQuery na Shoptetu je 1.11 — $.get() tam neumí objekt s nastavením (timeout), proto $.ajax()
    $.ajax({
        url: realizaceReviewsSources[index],
        dataType: "html",
        timeout: realizaceReviewsTimeout,
    }).done(function (data) {
        const $response = $($.parseHTML(data));
        const $votes = $response.find(".votes-wrap > .vote-wrap").filter(function () {
            return $(this).find(".star-on").length == 5 &&
                $(this).find(".vote-content").text().trim().length > settings.minTextLength;
        }).slice(0, settings.count);

        if ($votes.length) {
            onSuccess($votes);
        } else {
            tryNext();
        }
    }).fail(tryNext);
}

function initRealizace() {
    if (!$(".myrealizace").length || !shopDataLayer.realizace) {
        return;
    }

    initRealizaceGallery();
    initRealizaceReviews();
}

$(document).ready(function () {
    initRealizace();
});

document.addEventListener("ShoptetDOMContentLoaded", function () {
    initRealizace();
});
